import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} employees
 * @returns {Workbook}
 */
export const exportExcel = async (employees) => {
  employees.forEach((employee, index) => {
    employee.order = index + 1;
  });

  const json = excelHelper.jsonToJson(
    [employees],
    [
      {
        name: "EMPLEADOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "lastname",
            outValue: "APELLIDOS",
          },
          {
            inValue: "dni",
            outValue: "DNI",
          },
          {
            inValue: "cellphone",
            outValue: "NUMERO TELEFONICO",
          },
          {
            inValue: "email",
            outValue: "CORREO ELECTRONICO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-empleados.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeList/excel.js